export const EXPRESSION_BOX_CODE_BLOCK_CLS = 'expression_box_code_block';
export const EXPRESSION_BOX_EDITOR_CLS = 'expression_box_editor';
export const EXPRESSION_BOX_EXPAND_EDITOR_LABEL = 'Expand Editor';
export const EXPRESSION_BOX_VALUE_ATTR = 'data-expression-value';
export const EXPRESSION_ACTION_WRAPPER_CLS = 'expression_action_wrapper';
